var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedInLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0552 2.01025C9.88366 2.01025 2.4541 9.44725 2.4541 18.6114C2.4541 27.7755 9.88366 35.2125 19.0552 35.2125C28.2268 35.2125 35.6563 27.7829 35.6563 18.6114C35.6563 9.43981 28.2268 2.01025 19.0552 2.01025ZM13.3453 10.3108C14.2014 10.3108 14.9012 11.0106 14.9012 11.8667C14.9012 12.7228 14.2014 13.4226 13.3453 13.4226C12.4892 13.4226 11.7894 12.7228 11.7894 11.8667C11.7894 11.0106 12.4892 10.3108 13.3453 10.3108ZM14.9161 24.82H11.8043V14.4574H14.9161V24.82ZM27.3632 24.82H24.2514V19.1697C24.2514 18.0084 23.9164 16.8545 22.5541 16.8545C21.1918 16.8545 20.1049 18.0158 20.1049 19.1995V24.82H16.9857V14.4276H20.1049V15.8718C21.0652 14.6584 22.4127 14.1075 23.9239 14.1075C25.4351 14.1075 27.3707 14.8594 27.3707 18.9464V24.82H27.3632Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInLogo);
export default __webpack_public_path__ + "static/media/linkedInLogo.e814dd77e318ccaa9d2d755d9e00cf9b.svg";
export { ForwardRef as ReactComponent };